import ArchiveDataTable from 'app/components/DataTable/archive/ArchiveDataTable';
import React from 'react';

const ArchivePage = () => {
    const tableCellStyle = { fontSize: '10px' };
    const commonColumnStyle = { ...tableCellStyle, minWidth: 30, maxWidth: 50 };

    const columnData = [
        { id: 'inst', align: 'left', disablePadding: false, label: "Toplantı", sx: { ...tableCellStyle, maxWidth: 70 } },
        { id: 'meetingDate', align: 'left', disablePadding: false, label: "Tarih", sx: commonColumnStyle },
        { id: 'pageNumber', align: 'center', disablePadding: false, label: "Sayfa", sx: commonColumnStyle },
        { id: 'content', align: 'left', disablePadding: false, label: "Metin", sx: { ...tableCellStyle, minWidth: 300, maxWidth: 350 } },
        { id: 'islemler', align: 'center', disablePadding: false, label: "İşlemler", sx: { ...tableCellStyle, minWidth: 80, maxWidth: 100 } }
    ];

    return (
        <React.Fragment>
            <ArchiveDataTable mainData={[]} column={columnData} />
        </React.Fragment>
    );
};

export default ArchivePage;
